/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, func, string, shape,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = (theme) => ({
    tabsWrapper: {
        maxHeight: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 10,
        [theme.breakpoints.down('sm')]: {
            paddingTop: 0,
            height: 30,
            justifyContent: 'space-around',
        },
    },
    tabsWrapperReview: {
        maxHeight: 60,
        display: 'flex',
        alignItems: 'center',
        marginTop: 10,
        [theme.breakpoints.down('sm')]: {
            paddingTop: 0,
            height: 30,
            justifyContent: 'space-around',
        },
    },
    selectTemplate: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 0,
            '&::after': {
                content: '"Select"',
            },
        },
    },
    selectTab: {
        fontSize: 25,
        fontWeight: 'bold',
        lineHeight: '21px',
        textTransform: 'capitalize',
        padding: '10px 15px',
    },
    tab: {
        color: theme.palette.cgc?.bgTextOverlay1 || 'rgba(0,0,0,0.6)',
        textTransform: 'capitalize',
        padding: '0px 15px',
    },
    personalizeCard: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 0,
            '&::after': {
                content: '"Personalize"',
            },
        },
    },
    reviewCard: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 0,
            '&::after': {
                content: '"Review"',
            },
        },
    },
});

const CelebrationsCustomModalNav = ({
    classes, setCustomView, modalViews, selectedView, selectedCard, messageData, dataDictionary,
}) => {
    const personalizeDisabled = !(selectedCard.length > 0);
    const reviewDisabled = !(messageData?.text?.length > 0);
    return (
        <Grid item xs={12} className={classes.tabsWrapper}>
            <Grid>
                <Button
                    className={`${classes.selectTemplate} ${selectedView === modalViews.SELECT_TEMPLATE ? classes.selectTab : classes.tab}`}
                    onClick={() => setCustomView(modalViews.SELECT_TEMPLATE)}
                >
                    {dataDictionary?.['Select a Label'] || 'Select a Label'}
                </Button>
            </Grid>
            <Grid className={selectedView === modalViews.PERSONALIZE ? classes.selectTab : classes.tab}>
                <Button
                    className={`${classes.personalizeCard} ${selectedView === modalViews.PERSONALIZE ? classes.selectTab : classes.tab}`}
                    onClick={() => setCustomView(modalViews.PERSONALIZE)}
                    disabled={personalizeDisabled}
                >{dataDictionary?.['Customize Label'] || 'Customize Label'}
                </Button>
            </Grid>
            <Grid className={selectedView === modalViews.REVIEW ? classes.selectTab : classes.tab}>
                <Button
                    className={`${classes.reviewCard} ${selectedView === modalViews.REVIEW ? classes.selectTab : classes.tab}`}
                    onClick={() => setCustomView(modalViews.REVIEW)}
                    disabled={reviewDisabled}
                >
                    {dataDictionary?.['Review Label'] || 'Review Label'}
                </Button>
            </Grid>
        </Grid>
    );
};

CelebrationsCustomModalNav.propTypes = {
    classes: object.isRequired,
    setCustomView: func.isRequired,
    modalViews: shape({
        PERSONALIZE: string,
        REVIEW: string,
    }).isRequired,
    selectedView: string.isRequired,
    selectedCard: string.isRequired,
    messageData: shape({
        text: string,
    }).isRequired,
    dataDictionary: object,
};

CelebrationsCustomModalNav.defaultProps = {
    dataDictionary: {},
};
export default withStyles(styles)(CelebrationsCustomModalNav);
